// @flow

import React, { Component } from "react";
import { Map } from "immutable";
// material-ui components
import AppBar from "@material-ui/core/AppBar";
import logo from "./img/icpc-logo.png";
import logocmplay from "./img/icpc-logo-cmplay.png";

import TopToolbar from "./TopToolbar";
import BottomToolbar from "./BottomToolbar";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  appbar: {
    zIndex: 2,
    position: "fixed",
    top: 0,
    width: "100%",
    transition: "350ms ease-in-out",
  },
  appBarBackground: { backgroundColor: theme.palette.background.paper },
  stickied: {
    transform: "translateY(-50%)",
  },
});

type Props = {
  currentUser: Map<string, any>,
  canSeeContest: boolean,
  isAdmin: boolean,
  pathname: string,
  redirect: (string) => void,
  onButtonClick: Function,
  className: string,
  classes: Object,
  stickied: boolean,
  logout: Function,
};

class PrivateNavbar extends Component<Props> {
  handleChange = (event: Event, value: string) => {
    this.props.redirect(value);
  };

  render() {
    const { classes } = this.props;
    const appbarStickied: string = this.props.stickied
      ? `${classes.appbar} ${classes.stickied}`
      : `${classes.appbar}`;
    const cmplay = window.location.href.includes("cmplay.ecs.baylor.edu");
    return (
      <div>
        <div className={appbarStickied}>
          <AppBar position="static" className={classes.appBarBackground}>
            <TopToolbar
              logo={cmplay ? logocmplay : logo}
              logoAlt="Logo"
              to="/"
              currentUser={this.props.currentUser}
              logout={this.props.logout}
            />
            <BottomToolbar
              className={this.props.className}
              value={this.props.pathname}
              canSeeContest={this.props.canSeeContest}
              isAdmin={this.props.isAdmin}
              handleChange={this.handleChange}
              onButtonClick={this.props.onButtonClick}
            />
          </AppBar>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(PrivateNavbar);
